import { render, staticRenderFns } from "./SpotCharterDialog.vue?vue&type=template&id=15f8c434&"
import script from "./SpotCharterDialog.vue?vue&type=script&lang=js&"
export * from "./SpotCharterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports